<template>
    <div class="attribute-editor">
        <table class="w-100">
            <tr v-for="(value, attribute) in modelValue" :key="attribute">
                <td :class="[`align-middle low-title text-nowrap text-center pr-3`, {'text-primary': modelValue[attribute] < 5}]">{{ descriptors[attribute][0] }}</td>
                <td class="w-100">
                    <vue-slider class="ml-2 mr-2 my-2" 
                                v-model="modelValue[attribute]" 
                                :enable-cross="false" 
                                :min="0" 
                                :max="10" 
                                tooltip="none"
                                :use-keyboard="false">
                    </vue-slider>
                </td>
                <td :class="[`align-middle high-title text-nowrap text-center pl-3`, {'text-primary': modelValue[attribute] >= 5}]">{{ descriptors[attribute][1] }}</td>
            </tr>
        </table>
        
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
    name: 'AttributeEditor',
    model: {
        prop: 'modelValue',
        event: 'change',
    },
    components: {
        VueSlider,
    },
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            descriptors: {
                calmness: ['Energetic', 'Calm'],
                cleanliness: ['Dirty', 'Clean'],
                comfort: ['Uncomfortable', 'Comfortable'],
                development: ['Undeveloped', 'Developed'],
                nudity_level: ['More Clothed', 'More Naked'],
            }
        }
    },
};
</script>

<style lang="scss">
.attribute-editor {
    .vue-slider-process {
        background-color: $primary;
    }
    .vue-slider-dot-tooltip-inner {
        border-color: $primary;
        background-color: $primary;
    }
}
</style>